module.exports = __webpack_public_path__ + "static/media/screenshot(39).8daf095e.jpg";